import React, { useEffect } from "react";
import "./Flag.css";

// Importing the colors configuration from an external file
import { colors } from "../config";
import pronounComponents from "../pronouns.js";

// Setting the width and height of the flag
const width = 40;
const height = 24;

const FlagLastThree = ({
  hStripeColors = ["white"],
  vStripeColors = ["white"],
  poly = ["grey_2"],
  hoverPoly,
  hoverEmotional,
  hoverPhysical,
  hoverBoth,
  resetHover,
}) => {
  function opacityAdd(original) {
    const flagElements = [
      document.getElementById("poly"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.add("opacity-hovered");
        } catch (e) {}
      }
    });
  }
  function opacityAddMultiple(original, original2) {
    const flagElements = [
      document.getElementById("poly"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original && item !== original2) {
        try {
          item.classList.add("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  function opacityRemove(original) {
    const flagElements = [
      document.getElementById("poly"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.remove("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  //hovering poly symbol
  useEffect(() => {
    try {
      const polyImage = document.getElementById("poly");

      const handleMouseEnter = () => {
        hoverPoly();
        opacityAdd(polyImage);
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        resetHover();
        opacityRemove(polyImage);
      };

      polyImage.addEventListener("mouseenter", handleMouseEnter);
      polyImage.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        polyImage.removeEventListener("mouseenter", handleMouseEnter);
        polyImage.removeEventListener("mouseleave", handleMouseEnter);
      };
    } catch (e) {}
  }, [hoverPoly, resetHover]);

  //hovering vertical (emotional) stripes
  useEffect(() => {
    const vStripes = document.getElementById("vStripes");

    const handleMouseEnter = () => {
      hoverEmotional();
      opacityAdd(vStripes);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(vStripes);
    };

    vStripes.addEventListener("mouseenter", handleMouseEnter);
    vStripes.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      vStripes.removeEventListener("mouseenter", handleMouseEnter);
      vStripes.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverEmotional, resetHover]);

  //hovering horizontal (physical) stripes
  useEffect(() => {
    const hStripes = document.getElementById("hStripes");

    const handleMouseEnter = () => {
      hoverPhysical();
      opacityAdd(hStripes);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(hStripes);
    };

    hStripes.addEventListener("mouseenter", handleMouseEnter);
    hStripes.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      hStripes.removeEventListener("mouseenter", handleMouseEnter);
      hStripes.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverPhysical, resetHover]);

  //text hover for poly heart
  useEffect(() => {
    try {
      const text = document.getElementById("polyamorous");
      const poly = document.getElementById("poly");

      const handleMouseEnter = () => {
        opacityAdd(poly);
        hoverPoly();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(poly);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPoly, resetHover]);

  //text hover for physical attraction
  useEffect(() => {
    try {
      const text = document.getElementById("physical");
      const hStripes = document.getElementById("hStripes");

      const handleMouseEnter = () => {
        opacityAdd(hStripes);
        hoverPhysical();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(hStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPhysical, resetHover]);

  //text hover for emotional attraction
  useEffect(() => {
    try {
      const text = document.getElementById("emotional");
      const vStripes = document.getElementById("vStripes");

      const handleMouseEnter = () => {
        opacityAdd(vStripes);
        hoverEmotional();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(vStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverEmotional, resetHover]);

  //text hover for both emotional/physical attraction
  useEffect(() => {
    try {
      const text = document.getElementById("experience");
      const text2 = document.getElementById("experience2");
      const text3 = document.getElementById("experience3");
      const text4 = document.getElementById("experience4");
      const vStripes = document.getElementById("vStripes");
      const hStripes = document.getElementById("hStripes");

      const handleMouseEnter = () => {
        opacityAddMultiple(vStripes, hStripes);
        hoverBoth();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(vStripes);
        opacityRemove(hStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);
      text2.addEventListener("mouseenter", handleMouseEnter);
      text2.addEventListener("mouseleave", handleMouseLeave);
      text3.addEventListener("mouseenter", handleMouseEnter);
      text3.addEventListener("mouseleave", handleMouseLeave);
      text4.addEventListener("mouseenter", handleMouseEnter);
      text4.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
        text2.removeEventListener("mouseenter", handleMouseEnter);
        text2.removeEventListener("mouseleave", handleMouseLeave);
        text3.removeEventListener("mouseenter", handleMouseEnter);
        text3.removeEventListener("mouseleave", handleMouseLeave);
        text4.removeEventListener("mouseenter", handleMouseEnter);
        text4.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverBoth, resetHover]);

  // Generating horizontal stripes for the flag
  const hStripes = hStripeColors.map((color, i, s) => (
    <rect
      key={i}
      x={0}
      // Calculating the y position for each horizontal stripe
      y={(height * (3 / 5) * i) / s.length + height / 5}
      width={width}
      // Calculating the height of each horizontal stripe
      height={((height * (3 / 5)) / s.length + 0.1).toFixed(2)}
      // Filling the stripe with the corresponding color from the configuration
      fill={colors[color][2]}
    ></rect>
  ));

  // Generating vertical stripes for the flag
  const vStripes = vStripeColors.map((color, i, s) => (
    <React.Fragment key={i}>
      {/* Upper part of each vertical stripe */}
      <rect
        x={(width / s.length) * i}
        y={0}
        width={width / (s.length - 1 > 0 ? s.length : 1)}
        height={height / 5 + 0.05}
        fill={colors[color][3]}
      ></rect>
      {/* Lower part of each vertical stripe */}
      <rect
        x={(width / s.length) * i}
        y={((height * 2) / 5) * 2}
        width={width / (s.length - 1 > 0 ? s.length : 1)}
        height={height / 5}
        fill={colors[color][3]}
      ></rect>
    </React.Fragment>
  ));

  const polySymbol = (selected) => {
    let symbol = null;
    if (selected[0] === "grey") {
      symbol = pronounComponents()[selected];
    }

    return symbol;
  };

  return (
    <div className="flag-container" border="2px solid black">
      <svg
        id={"flag"}
        className="flag"
        viewBox={`0 0 ${width} ${height}`}
        // Specifying the XML namespace for SVG
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Including horizontal and vertical stripes */}

        <svg
          id="hStripes"
          viewBox={`0 0 600 600`}
          height={height * 25}
          width={width * 25}
          x={-200}
          y={0}
        >
          {hStripes}
        </svg>

        <svg
          id="vStripes"
          viewBox={`0 0 600 600`}
          height={height * 25}
          width={width * 25}
          x={-200}
          y={0}
        >
          {vStripes}
        </svg>

        <svg
          viewBox={`0 0 1500 1500`}
          height={height * 6.5}
          width={width * 6.5}
          x={width - 82}
          y={height / 3 - 6.45}
          xmlns="http://www.w3.org/2000/svg"
        >
          {polySymbol(poly)}
        </svg>
      </svg>
    </div>
  );
};

export default FlagLastThree;
